import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { LegView } from '@sequence/models/view/leg.view';
import { WeatherStore } from '../weather.store';
import { Observable, distinctUntilChanged, map, timer } from 'rxjs';
import { WeatherView } from '../models/weather.view';
import { RequestState } from '@shared/models/request-state';
import { fadeIn } from '@animations/fade-in';
import { DateTime } from 'luxon';
import { DataItem } from '@shared/models/data-item';

@Component({
  selector: 'app-weather-card',
  templateUrl: './weather-card.component.html',
  styleUrls: ['./weather-card.component.scss'],
  standalone: false,
  animations: [fadeIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherCardComponent implements OnInit, OnChanges {
  @Input() flightState?: LegView;
  weather$?: Observable<RequestState<WeatherView>>;
  currentZulu$?: Observable<DateTime>;
  zuluDataItems$?: Observable<DataItem[]>;

  constructor(private weatherStore: WeatherStore) {}

  ngOnInit(): void {
    this.currentZulu$ = timer(0, 1000).pipe(
      map(() => {
        return DateTime.now().toUTC();
      }),
      distinctUntilChanged(),
    );
  }

  ngOnChanges(): void {
    // Update weather if flight changes.
    this.getWeather();
  }

  onExpand(): void {
    this.getWeather();
  }

  refresh(): void {
    this.getWeather(true);
  }

  getWeather(isRefresh = false): void {
    if (this.flightState) {
      this.weather$ = this.weatherStore.getWeather(this.flightState, isRefresh);
    }
  }
}
